import { ResidentFeedbackDto } from '../bot';

export class DialogDto {
  feedback?: ResidentFeedbackDto;
}
